<template>
  <div
    :title="params.name ? params.name : params.displayName"
    class="attendance_goal_header__title"
  >
    <div
      v-if="params.name"
      class="link"
      @click="click"
    >
      <span style="color: #b71c1c"> {{ params.name }} </span>
    </div>
    <div v-else>
      {{ params.displayName }}
    </div>
  </div>
</template>

<script>
import Vue from 'vue'

export default Vue.extend({
  name: 'AttendanceGoalMatrixHeader',

  data () {
    return {
      params: null,
    }
  },

  methods: {
    click () {
      this.params.column.colDef.onClick()
    },
  },
})
</script>

<style lang="scss">
.attendance_goal_header__title {
  font-size: 14px;
  padding: 0px;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;

  .link {
    cursor: pointer;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}
</style>
